module.exports = __webpack_public_path__ + "static/img/bg-pt.c86d553a.webp";